import { forwardRef } from "react";
import { cn } from "@/utils";

interface TableCellProps extends React.TdHTMLAttributes<HTMLTableCellElement> {
	align?: "left" | "center" | "right";
}

export const TableCell = forwardRef<HTMLTableCellElement, TableCellProps>(
	function TableCell({ children, className, align = "left", ...props }, ref) {
		const alignmentClass = {
			left: "text-left",
			center: "text-center",
			right: "text-right",
		}[align];

		return (
			<td
				ref={ref}
				className={cn(
					"px-4 py-3 whitespace-nowrap text-xs",
					alignmentClass,
					className,
				)}
				{...props}
			>
				{children}
			</td>
		);
	},
);
